var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCigarette = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132_18663)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M30.0017 20C29.39 20 28.8017 19.6633 28.5083 19.0783C27.385 16.8316 25.2833 15.9966 22.85 15.0283C19.3533 13.6383 15 11.9083 15 4.99998C15 4.07998 15.7467 3.33331 16.6667 3.33331C17.5867 3.33331 18.3333 4.07998 18.3333 4.99998C18.3333 9.64665 20.745 10.605 24.0817 11.9316C26.7617 12.9966 29.7983 14.2033 31.49 17.5883C31.9017 18.4116 31.5683 19.4133 30.745 19.825C30.5067 19.9433 30.2517 20 30.0017 20ZM36.6667 18.3333C35.7467 18.3333 35 17.5866 35 16.6666C35 14.2683 34.065 13.3333 31.6667 13.3333C30.7467 13.3333 30 12.5866 30 11.6666C30 9.33665 27.47 8.33331 26.6667 8.33331C25.7467 8.33331 25 7.58665 25 6.66665C25 5.74665 25.7467 4.99998 26.6667 4.99998C28.76 4.99998 32.2967 6.70665 33.1467 10.1083C36.4633 10.625 38.3333 12.9516 38.3333 16.6666C38.3333 17.5866 37.5867 18.3333 36.6667 18.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5 23.3333C2.23833 23.3333 0 25.5716 0 28.3333C0 31.095 2.23833 33.3333 5 33.3333C6.06 33.3333 19.8 33.3333 28.3333 33.3333V23.3333C19.8 23.3333 6.06 23.3333 5 23.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 23.3333C34.5583 23.3333 31.8966 23.3333 28.3333 23.3333V33.3333C31.8966 33.3333 34.5583 33.3333 34.9999 33.3333C37.7616 33.3333 39.9999 31.095 39.9999 28.3333C39.9999 25.5716 37.7616 23.3333 34.9999 23.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 23.3333H10V33.3333H13.3333V23.3333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 31.6667C13.5075 31.6667 14.9999 30.1743 14.9999 28.3333C14.9999 26.4924 13.5075 25 11.6666 25C9.82564 25 8.33325 26.4924 8.33325 28.3333C8.33325 30.1743 9.82564 31.6667 11.6666 31.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132_18663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCigarette, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cigarette.bbf531a2.svg";
export { ForwardRef as ReactComponent };